import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  DeglawyPortalContent, IDeglawyPortalContentStore,
} from '../../mobx-store/storeInterfaces/deglawyPortalContentInterface';

interface IProps extends WithSnackbarProps {
  deglawyPortalContentStore: IDeglawyPortalContentStore;
  history: any;
}

interface TableData {
  id: number;
  title: string;
  body: string;
  edit: string;
}

@inject('deglawyPortalContentStore')
@observer
class DeglawyPortalContents extends Component<IProps> {
  tableHeader: any = [];

  tableData: TableData[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title = 'Deglawy Portal Content Management';

  constructor(props: IProps) {
    super(props);
  }

  handleTableButtonCellClicked = (index: number, key: string) => {
    console.log(this.props.deglawyPortalContentStore.deglawyPortalContentsList);
    this.props.history.push(`/deglawy/portal/contents/${this.props.deglawyPortalContentStore.deglawyPortalContentsList[index].getId()}/edit`);
  };

  getDeglawyPortalContentTableHeader = () => [
    {
      title: translate('deglawyContentsTitlesColumnTitle', {
      }),
    },
    {
      title: translate('deglawyContentsEditColumnTitle', {
      }),
    },
  ];

  getDeglawyPortalContentTableData = (): TableData[] => this.props.deglawyPortalContentStore.deglawyPortalContentsList
    .map((deglawyPortalContent: DeglawyPortalContent) => {
      console.log(deglawyPortalContent);
      const deglawyPortalContentData = {
        id: deglawyPortalContent.getId(),
        title: translate(`${deglawyPortalContent.getTitle()}`, {
        }),
        body: deglawyPortalContent.getBody(),
        edit: 'Edit',
      };
      return deglawyPortalContentData;
    });

  getDeglawyPortalContentTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  render() {
    this.tableHeader = this.getDeglawyPortalContentTableHeader();
    this.tableData = this.getDeglawyPortalContentTableData();
    this.tableCellTypes = this.getDeglawyPortalContentTableCellTypes();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage="There are no contents yet."
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          loading={this.props.deglawyPortalContentStore.loading}
        />
      </div>
    );
  }

  componentDidMount() {
    this.props.deglawyPortalContentStore.getDeglawyContents(DefaultLanguage);
  }
}

export default DeglawyPortalContents;
